/** Placeholder testimonials — replace with real, approved client reviews. */
export const TESTIMONIALS = [
  {
    quote: "Placeholder testimonial. A real client review will appear here once it has been provided and approved by the client.",
    name: "Client name — placeholder",
    role: "Business type — placeholder",
  },
  {
    quote: "Placeholder testimonial. This slot is reserved for feedback from a restaurant, automotive or contractor client.",
    name: "Client name — placeholder",
    role: "Business type — placeholder",
  },
  {
    quote: "Placeholder testimonial. No reviews are shown until they are real and supplied by NEXORA Web Studio.",
    name: "Client name — placeholder",
    role: "Business type — placeholder",
  },
];
